import { Card, Flex, Spin, Table, TableProps, Typography } from "antd";
import { Availability } from "../../../api/slowboatApi";
import { useGetInventoryOverviewQuery } from "../../../api/inventory/inventoryApi";
import { useGetQrApiUsageOverviewQuery } from "../../../api/redemption/redemptionApi";

const columns: TableProps<Availability>["columns"] = [
  {
    title: "SKU",
    dataIndex: "title",
    key: "title",
  },
  {
    title: "Quantity",
    dataIndex: "count",
    key: "count",
    render: (count: number) => count === 0 ? "Out of Stock" : count
  }
]

export default function QrApiUsageCard() {
  const { data, error, isFetching } = useGetQrApiUsageOverviewQuery();

  return (
    <Card title="QR API Usage" style={{ width: "100%", height: "100%" }}>
      { isFetching &&
        <Flex justify="center" align="center" style={{ height: "100%" }}>
          <Spin />
        </Flex>
      }
      { error && <Typography.Text>Error loading QR API usage</Typography.Text> }
      { data && !isFetching &&
        <Flex vertical gap={8}>
          <Typography.Text>This Month</Typography.Text>
          <Typography.Title level={2} style={{ marginTop: 0 }}>{data.count} / 3000</Typography.Title>
        </Flex>
      }
    </Card>
  )
}